module.exports = __webpack_public_path__ + "img/jp_xianglu.e2bb8b51.png";